
// @ts-nocheck


export const localeCodes =  [
  "en",
  "fr",
  "it",
  "de",
  "hy",
  "ru"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_6de9087c",
      load: () => import("#nuxt-i18n/6de9087c" /* webpackChunkName: "locale_en_46json_6de9087c" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46json_ce118e26",
      load: () => import("#nuxt-i18n/ce118e26" /* webpackChunkName: "locale_fr_46json_ce118e26" */),
      cache: true
    }
  ],
  it: [
    {
      key: "locale_it_46json_9ce665f2",
      load: () => import("#nuxt-i18n/9ce665f2" /* webpackChunkName: "locale_it_46json_9ce665f2" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_710dabc6",
      load: () => import("#nuxt-i18n/710dabc6" /* webpackChunkName: "locale_de_46json_710dabc6" */),
      cache: true
    }
  ],
  hy: [
    {
      key: "locale_hy_46json_1f3304ce",
      load: () => import("#nuxt-i18n/1f3304ce" /* webpackChunkName: "locale_hy_46json_1f3304ce" */),
      cache: true
    }
  ],
  ru: [
    {
      key: "locale_ru_46json_f9a4ea42",
      load: () => import("#nuxt-i18n/f9a4ea42" /* webpackChunkName: "locale_ru_46json_f9a4ea42" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      name: "English",
      files: [
        {
          path: "/var/www/scan.ova-restaurant.com/i18n/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      name: "Français",
      files: [
        {
          path: "/var/www/scan.ova-restaurant.com/i18n/locales/fr.json",
          cache: undefined
        }
      ]
    },
    {
      code: "it",
      name: "Italian",
      files: [
        {
          path: "/var/www/scan.ova-restaurant.com/i18n/locales/it.json",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      name: "German",
      files: [
        {
          path: "/var/www/scan.ova-restaurant.com/i18n/locales/de.json",
          cache: undefined
        }
      ]
    },
    {
      code: "hy",
      name: "Armenian",
      files: [
        {
          path: "/var/www/scan.ova-restaurant.com/i18n/locales/hy.json",
          cache: undefined
        }
      ]
    },
    {
      code: "ru",
      name: "Russian",
      files: [
        {
          path: "/var/www/scan.ova-restaurant.com/i18n/locales/ru.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: true,
  langDir: "locales/",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    files: [
      {
        path: "/var/www/scan.ova-restaurant.com/i18n/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    name: "Français",
    files: [
      {
        path: "/var/www/scan.ova-restaurant.com/i18n/locales/fr.json",
        cache: undefined
      }
    ]
  },
  {
    code: "it",
    name: "Italian",
    files: [
      {
        path: "/var/www/scan.ova-restaurant.com/i18n/locales/it.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    name: "German",
    files: [
      {
        path: "/var/www/scan.ova-restaurant.com/i18n/locales/de.json",
        cache: undefined
      }
    ]
  },
  {
    code: "hy",
    name: "Armenian",
    files: [
      {
        path: "/var/www/scan.ova-restaurant.com/i18n/locales/hy.json",
        cache: undefined
      }
    ]
  },
  {
    code: "ru",
    name: "Russian",
    files: [
      {
        path: "/var/www/scan.ova-restaurant.com/i18n/locales/ru.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/